import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { P2, Button } from 'pfm-ui-components';
import Link from 'next/link';
import { routes } from '../../../config/routes';
import * as constants from '../../../constants/NavigationTab';
import { getIconForNavigationTab } from './util';
import { hexToRgba, pxToRem } from '../../../styles/utils';
import { featureToggle } from '../../../constants/common';
import { Col } from 'react-awesome-styled-grid';
import { useRouter } from 'next/router';
import { up } from 'styled-breakpoints';
import GTM from '../../../GTM';
interface NavigationFooterTabProps {
  hasPortfolio: boolean; // used to show portfolio tab
  activeMenu: number; // to highlight the current tab
  hasNotificationIcon: boolean;
  onOpenNotification?: Function;
  notificationCount?: number;
  hideNotificationCountNumber?: boolean;
  isLoggedIn?: boolean;
  onLoginToViewPortfolioButtonClick?: Function;
  enableFAQ: boolean;
  enableNotification: boolean;
  onUserGuideClick?: Function;
  enableDisableDropDown?: boolean;
}
const NavigationContainer = styled.div`
  width: 100%;
  height: ${pxToRem(64)};
  bottom: 0;
  position: fixed;
`;

const MenuContainer = styled.article<{ enableShadow: boolean }>`
  display: flex;
  justify-content: flex-start;
  border-radius: ${pxToRem(12)} ${pxToRem(12)} 0 0;
  background-color: ${(props) => props.theme.palette.white};
  height: 100%;
  padding: ${pxToRem(6)} ${pxToRem(6)};
  // TODO - uncomment this line after beta live
  box-shadow: ${(props) =>
    props.enableShadow
      ? `0 ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(1000)} ${hexToRgba(props.theme.palette.black, 0.16)}`
      : 'none'};
  z-index: 2;
`;

const MenuWrapper = styled.article<{ menuStyle?: string }>`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.menuStyle === 'inline' ? 'row' : 'column')};
  align-items: center;
  /* padding-top: ${pxToRem(4)}; */
  cursor: pointer;
`;

const PortfolioWrapper = styled(MenuWrapper) <{ showPortfolio: boolean }>`
  display: ${(props) => (props.showPortfolio ? 'flex' : 'none')};
`;

const DropDownWrapper = styled.article`
  width: 100%;
`;

const DropDownContainer = styled.article<{ toggleDropDown: boolean, showUserGuide: boolean }>`
  position: absolute;
  display: ${(props) => (props.toggleDropDown ? 'flex' : 'none')};
  z-index: 1;
  bottom: ${pxToRem(55)};
  right: ${pxToRem(1)};
  background-color: ${(props) => props.theme.palette.white};

  z-index: 2;
  width: ${pxToRem(128)};
  height: ${(props) => (props.showUserGuide ? pxToRem(132) : pxToRem(88))};
  border-radius: ${pxToRem(12)};
  margin: ${pxToRem(8)};
  padding-left: ${pxToRem(18)};
  flex-direction: column-reverse;
`;

const DropDownOption = styled(MenuWrapper)`
  padding-top: ${pxToRem(8)};
  padding-bottom: ${pxToRem(10)};
`;
const StyledP2 = styled(P2) <{ dropDownMenu: boolean; active: boolean }>`
  line-height: ${pxToRem(15)};
  color: ${(props) => (props.active ? props.theme.palette.burgundy1 : '#4a4a4a')};
  padding: ${(props) => (props.dropDownMenu ? '0  0 0 8px' : '4px 0 0 0')};
`;

const NotificationWrapper = styled(DropDownContainer)`
  width: auto;
  height: ${pxToRem(48)};
  border-radius: ${pxToRem(160)};
  padding: ${pxToRem(13)} ${pxToRem(16)};
  bottom: ${pxToRem(60)};
  right: ${pxToRem(3)};
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed11644d;
`;

const NotificationCounter = styled(P2) <{ disableNotificationCount: boolean }>`
  position: absolute;
  right: ${pxToRem(1)};
  top: ${pxToRem(1)};
  border-radius: ${pxToRem(50)};
  width: ${pxToRem(16)};
  height: ${pxToRem(14)};
  color: ${(props) => props.theme.palette.white};
  line-height: ${pxToRem(12)};
  font-size: ${pxToRem(10)};
  text-align: center;
  display: ${(props) => (props.disableNotificationCount ? 'none' : 'inline')};
  background-color: ${(props) => props.theme.palette.burgundy1};
`;

const StyledCol = styled(Col)`
  padding: 0;
  margin: ${pxToRem(8)} ${pxToRem(8)};
`;

const Divider = styled.article`
  border-bottom: ${pxToRem(2)} solid ${(props) => props.theme.palette.grey4};
  margin: 0 ${pxToRem(8)} 0 0;
  opacity: 0.6;
  ${up('md')} {
    margin: 0 ${pxToRem(16)} 0 0;
  }
`;

const UserGuideSpotlight = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column
`;

const UserGuideSpotlightProfile = styled.div`
  display: flex;
  align-items: center;
`;

export default function NavigationFooterTab(props: NavigationFooterTabProps) {
  const {
    hasPortfolio,
    activeMenu,
    hasNotificationIcon,
    onOpenNotification,
    notificationCount,
    hideNotificationCountNumber,
    isLoggedIn,
    onLoginToViewPortfolioButtonClick,
    enableFAQ,
    enableNotification,
    onUserGuideClick,
    enableDisableDropDown
  } = props;
  const [toggleDropDown, setToggleDropDown] = useState(true);
  const [currentActiveMenu, setCurrenActiveMenu] = useState(activeMenu);
  const router = useRouter();

  /*
   * onChangeDropDown - this handler is used to highlight the quickAccess button and draken the
   *                     background with popup of dropdown
   */
  const onChangeDropDown = () => {
    !toggleDropDown ? setCurrenActiveMenu(activeMenu) : setCurrenActiveMenu(4);
    setToggleDropDown(!toggleDropDown);
  };


  useEffect(() => {
    if (enableDisableDropDown === true || enableDisableDropDown === false) {
      !enableDisableDropDown ? setCurrenActiveMenu(activeMenu) : setCurrenActiveMenu(4);
      setToggleDropDown(!enableDisableDropDown);
    }
  }, [enableDisableDropDown]);

  return (
    <NavigationContainer>
      <MenuContainer enableShadow={!toggleDropDown}>
        {isLoggedIn && (
          <>
            <NavigationFooterTabContainer>
              <div onClick={() => GTM.mobileNavigation.onButtonClick(constants.INVESTMENT)}>
                <Link href={`${routes.INVEST.url}`}>
                  <MenuWrapper>
                    {currentActiveMenu === 1
                      ? getIconForNavigationTab('InvestmentBurgundySvg')
                      : getIconForNavigationTab('InvestmentGreySvg')}
                    <StyledP2 active={currentActiveMenu === 1}>{constants.INVESTMENT}</StyledP2>
                  </MenuWrapper>
                </Link>
              </div>

              <div onClick={() => GTM.mobileNavigation.onButtonClick(constants.INVEST)}>
                <Link href={`${routes.MUTUAL_FUND.url}`}>
                  <MenuWrapper>
                    {currentActiveMenu === 2
                      ? getIconForNavigationTab('ExploreBurgundySvg')
                      : getIconForNavigationTab('ExploreGreySvg')}
                    <StyledP2 active={currentActiveMenu === 2}>{constants.INVEST}</StyledP2>
                  </MenuWrapper>
                </Link>
              </div>
              {hasPortfolio &&
                <div onClick={() => GTM.mobileNavigation.onButtonClick(constants.PORTFOLIO)}>
                  <Link href={`${routes.PORTFOLIO.url}`}>
                    <PortfolioWrapper showPortfolio={hasPortfolio}>
                      <UserGuideSpotlight id='mf_user_guide_portfolio_nav_footer'>
                        {currentActiveMenu === 3
                          ? getIconForNavigationTab('FolioBurgundySvg')
                          : getIconForNavigationTab('FolioGreySvg')}
                        <StyledP2 active={currentActiveMenu === 3}>{constants.PORTFOLIO}</StyledP2>
                      </UserGuideSpotlight>
                    </PortfolioWrapper>
                  </Link>
                </div>
              }
              <div onClick={() => GTM.mobileNavigation.onButtonClick(constants.QUICK_ACCESS)}>
                <DropDownWrapper>
                  <MenuWrapper onClick={() => onChangeDropDown()}>
                    {currentActiveMenu === 4
                      ? getIconForNavigationTab('QuickAccessBurgundySvg')
                      : getIconForNavigationTab('QuickAccessGreySvg')}
                    <StyledP2 active={currentActiveMenu === 4}>{constants.QUICK_ACCESS}</StyledP2>
                  </MenuWrapper>
                  {enableFAQ && (
                    <DropDownContainer toggleDropDown={!toggleDropDown} showUserGuide={(router.pathname === "/mutualFunds" || router.pathname === "/portfolio")}>
                      <div onClick={() => GTM.mobileNavigation.onButtonClick(constants.FAQS)}>
                        <Link href={`${routes.FAQ.url}`}>
                          <DropDownOption menuStyle="inline">
                            {getIconForNavigationTab('FAQSvg')}
                            <StyledP2 dropDownMenu={true}>{constants.FAQS}</StyledP2>
                          </DropDownOption>
                        </Link>
                      </div>
                      <Divider />
                      <div onClick={() => GTM.mobileNavigation.onButtonClick(constants.MY_PROFILE)}>
                        <Link href={`${routes.PROFILE.url}`}>
                          <DropDownOption menuStyle="inline">
                            <UserGuideSpotlightProfile id='folio_cards_profile_footer'>
                              {getIconForNavigationTab('MyProfileSvg')}
                              <StyledP2 dropDownMenu={true}>{constants.MY_PROFILE}</StyledP2>
                            </UserGuideSpotlightProfile>
                          </DropDownOption>
                        </Link>
                      </div>
                      {(router.pathname === "/mutualFunds" || router.pathname === "/portfolio") &&
                        (
                          <>
                            <Divider />
                            <DropDownOption menuStyle="inline" onClick={() => { onUserGuideClick(); onChangeDropDown(); }}>
                              {getIconForNavigationTab('UserGuideSvg')}
                              <StyledP2 dropDownMenu={true}>{constants.USER_GUIDE}</StyledP2>
                            </DropDownOption>
                          </>)}
                    </DropDownContainer>
                  )}
                  {enableNotification && (
                    <NotificationWrapper
                      toggleDropDown={toggleDropDown && hasNotificationIcon}
                      onClick={() => onOpenNotification()}
                    >
                      {getIconForNavigationTab('NotificationSvg')}
                      {notificationCount ? (
                        <NotificationCounter disableNotificationCount={hideNotificationCountNumber}>
                          {notificationCount}
                        </NotificationCounter>
                      ) : (
                        ''
                      )}
                    </NotificationWrapper>
                  )}
                </DropDownWrapper>
              </div>
            </NavigationFooterTabContainer>
          </>
        )}

        {isLoggedIn !== undefined && !isLoggedIn && (
          <StyledCol xs={12}>
            <Button primary onClick={onLoginToViewPortfolioButtonClick}>
              {constants.LOGIN_TO_VIEW_PORTFOLIO}
            </Button>
          </StyledCol>
        )}
      </MenuContainer>
    </NavigationContainer>
  );
}

const NavigationFooterTabContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
justify-content: space-around;`
